export default "__VITE_ASSET__933181e9__"